/* © CNES */
import './StartGuidContent.scss';

/**
 * Start Guide Content Component.
 * @param title title of the start Guide
 * @param body body of the start Guide
 * @param icon icon of the start Guide
 * @param showMore showMore information of the start Guide
 * @param isMandatory isMandatory tag of the start Guide
 * @returns JSX.Element
 */
export const StartGuidContent = ({
  title,
  body,
  icon,
  showMore,
  isMandatory,
}: {
  title: string;
  body: string;
  icon: string;
  showMore?: Function;
  isMandatory?: boolean;
}) => {
  return (
    <div className="start-guid-content">
      <div className="title">
        <img alt="icon" src={require(`../../../assets/icons/${icon}`)} />
        {title}
        {isMandatory && <div className="tag">Mandatory</div>}
      </div>
      <div className="body">{body.split('<br/>').join('\n')}</div>
      {showMore && (
        <div className="show-more-button">
          <img
            alt="show more"
            src={require('../../../assets/icons/add.png')}
            onClick={() => showMore()}
          />
        </div>
      )}
    </div>
  );
};

/**
 * start Guide Style
 */
export const startGuidStyle = {
  options: {
    zIndex: 1103,
  },
  container: {
    backgroundColor: '#113268',
    borderRadius: 5,
    color: '#fff',
    filter: 'none',
    minHeight: 'none',
    maxWidth: 220,
    padding: 15,
    width: 220,
  },
  arrow: {
    color: '#113268',
    length: 20,
    spread: 23,
  },
};
